// extracted by css-extract-rspack-plugin
export default {"cell":"CompareWarehousesMiniGrid_cell__v3V9w"};